/**
 * Stable remount key for <ExtxyzTable> in SavedCrystalsPage. I4: the table's CIF/analysis
 * caches are initialized once per mount, keyed by the FILTERED candidates array's positional
 * index. With no key, changing the stage filter (or un-starring a candidate) re-renders the
 * SAME component instance with a different candidate-at-each-index mapping, so its stale
 * idx→data cache persists — an analysis computed for one crystal then gets persisted under a
 * DIFFERENT crystal's fingerprint (_fpFrame). Keying on each candidate's stable `fingerprint`
 * (never array index — both membership AND order changes must force a remount) makes this key
 * change exactly when the filtered set changes, forcing a fresh mount and a correctly-aligned
 * cache re-init from the freshly-computed frames/meta/initialCache props.
 */
export function extxyzRemountKey(stageFilter, candidates) {
  const ids = (Array.isArray(candidates) ? candidates : [])
    .map((c) => (c && (c.fingerprint || c.id)) || '')
    .join('|');
  return `${stageFilter || 'all'}:${ids}`;
}
